import axios from "axios";
import Constant from "../Utils/Constant";
const AxiosInstance = axios.create({
  baseURL: Constant.BASE_URL,
});
AxiosInstance.interceptors.request.use(
  function (config) {
    const timeSheet = JSON.parse(localStorage.getItem("TimeSheet"));
    
    config.headers.token = timeSheet?.user_details?.token;
    config.headers.apikey = timeSheet?.user_details?.apikey;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
);

export default AxiosInstance;
